import { useMemo } from "react";
import { makeQueryString } from "core/makeQueryString";
import { useFetchGet } from "hooks/fetch/useFetchGet";
import { Tag } from "interfaces/tag";

/** The object returned from the get tags hook  */
export type GetTagsResponse = {
  loading: boolean;
  error: boolean;
  tags: Tag[];
  count: number;
};

/** The response returned from the get tags fetch */
type FetchGetTagsResponse = {
  loading: boolean;
  error: boolean;
  response?: {
    results: Tag[];
    count: number;
  };
  refetch: () => void;
};

export interface useGetTagsArgs {
  /** page the current page, defaults to the first page */
  page?: number;
  /** the size of the page, defaults to 10000 */
  pageSize?: number | string;
  visible?: number;
  ordering?: string | null;
}

export function useGetTags(optional: useGetTagsArgs = {}): GetTagsResponse {
  const {
    page = 1,
    pageSize = 9999999,
    visible = 1,
    ordering = null
  } = optional;
  const url = useMemo(
    () =>
      `tags` +
      makeQueryString({
        page,
        size: pageSize,
        visible: visible,
        ordering: ordering
      }),
    [page, pageSize, visible, ordering]
  );

  const {
    loading,
    error,
    response = { results: [], count: 0 }
  }: FetchGetTagsResponse = useFetchGet(url);

  return {
    loading,
    error,
    tags: response.results,
    count: response.count
  };
}
